import moment from 'moment';
import LineComp from './componment/LineComp';
import TipTitle from '@/components/TipTitle';


export const siteTypeCode = {
  '900800': 2, // 营业区
  '900100': 3, // 分拨
};

export const getDatas = (data = [], searchQuery) => {
  let locationData = [];
  let areaData = [];
  // 分拨
  if (searchQuery?.organizationName?.siteTypeCode === '900100') {
    data.forEach(item => {
      locationData.push(item);
    });
    // 总部和营业区
  } else {
    data.forEach(item => {
      areaData.push(item);
      if (item.children && item.children.length > 0) {
        item.children.forEach(value => {
          locationData.push(value);
        });
      }
    });
  }
  return {
    locationData,
    areaData,
  };
};

export function transformArray(inputArray) {
  const transformedArray = [];

  inputArray.forEach(item => {
    const { ofDay, ratio, ratioOfOperator, ratioOfTransport } = item;

    transformedArray.push({
      ofDay,
      value: Number(ratio),
      name: '中转及时率',
    });

    transformedArray.push({
      ofDay,
      value: Number(ratioOfTransport),
      name: '运输延误',
    });

    transformedArray.push({
      ofDay,
      value: Number(ratioOfOperator),
      name: '操作延误',
    });
  });

  return transformedArray;
}

export function getDate() {
  const currentTime = moment();
  const cutoffTime = moment().set({ hour: 12, minute: 0, second: 0, millisecond: 0 });

  if (currentTime.isBefore(cutoffTime)) {
    return currentTime.subtract(2, 'days').format('YYYY-MM-DD');
  } else {
    return currentTime.subtract(1, 'days').format('YYYY-MM-DD');
  }
}

/**
 *
 * @param {dataIndex} 字段
 * @param {value} 值
 * @param {filterData} 筛选的数据
 * @returns
 */
const getValueAndPer = ({ dataIndex, value, filterData }) => {
  let maxAbsValue = filterData.reduce((maxValue, obj) => {
    const absValue = Math.abs(obj[dataIndex]);
    return Math.max(maxValue, absValue);
  }, 0);
  const per = (1 / maxAbsValue) * Math.abs(Number(value * 100));
  const val = (value && value * 100) || 0;
  return {
    per,
    val,
  };
};
/**
 * 
 * @param {*} baseDate 日期
 * @param {*} differ 差值 
 */
const getWeekScope = (baseDate, differ = 0) => {
  // 获取上周的开始日期（周一）
  const lastWeekStartDate = moment(baseDate).clone().subtract(differ, 'weeks').startOf('isoWeek');
  const lastWeekEndDate = moment(baseDate).clone().subtract(differ, 'weeks').endOf('isoWeek');
  return `(${lastWeekStartDate.format('M.DD')}-${lastWeekEndDate.format('M.DD')})`;
};

export const columns = ({ locationData = [], areaData = [], baseDate }) => {
  const today = moment(baseDate).format('MM-DD');
  const yesterday = moment(baseDate).subtract(1, 'days').format('MM-DD');
  const beforeYesterday = moment(baseDate).subtract(2, 'days').format('MM-DD');
  const month = moment(baseDate).format('M').trim();
  // console.log("导出日期", baseDate);
  const data = {
    '1': areaData,
    '2': areaData,
    '3': locationData,
  };
  return [
    {
      title: '营运区/分拨',
      align: 'left',
      dataIndex: 'name',
      width: 120,
      ellipsis: true,
    },
    // {
    //   title: '月累计',
    //   dataIndex: 'ratioOfCurrentMonth',
    //   align: 'center',
    //   width: 80,
    //   ellipsis: true,
    //   render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
    // },
    {
      title: '月对比', dataIndex: 'ydb', align: 'center',
      children: [
        {
          title: `${month}月累计`,
          dataIndex: 'ratioOfCurrentMonth',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: '月对比',
          dataIndex: 'ratioOfMonthOverMonth',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
      ]
    },

    // {
    //   title: '本周',
    //   dataIndex: 'ratioOfCurrentWeek',
    //   align: 'center',
    //   width: 80,
    //   ellipsis: true,
    //   render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
    // },
    // {
    //   title: '环比上周',
    //   dataIndex: 'ratioOfWeekOverWeek',
    //   align: 'center',
    //   width: 80,
    //   ellipsis: true,
    //   render: (value, record) => {
    //     const { per, val } = getValueAndPer({
    //       value,
    //       dataIndex: 'ratioOfWeekOverWeek',
    //       filterData: data[record.type] || [],
    //     });
    //     return <LineComp value={val} per={per} />;
    //   },
    // },
    {
      title: '周对比', dataIndex: 'zdb', align: 'center',
      children: [
        {
          title: (
            <div>
              <div>上周</div>
              <div>{getWeekScope(baseDate, 1)}</div>
            </div>
          ),
          dataIndex: 'ratioOfLastWeek',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: (
            <div>
              <div>本周</div>
              <div>{getWeekScope(baseDate, 0)}</div>
            </div>
          ),
          dataIndex: 'ratioOfCurrentWeek',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: '周对比',
          dataIndex: 'ratioOfWeekOverWeek',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: (value, record) => {
            const { per, val } = getValueAndPer({
              value,
              dataIndex: 'ratioOfWeekOverWeek',
              filterData: data[record.type] || [],
            });
            return <LineComp value={val} per={per} />;
          },
        },
      ]
    },
    {
      title: '日对比', dataIndex: 'rdb', align: 'center',
      children: [
        {
          title: beforeYesterday,
          dataIndex: 'ratioOfBeforeYesterday',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: yesterday,
          dataIndex: 'ratioOfYesterday',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: today,
          dataIndex: 'ratioOfCurrentDay',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: '日对比',
          dataIndex: 'ratioOfDayOnDay',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
      ]
    },
    {
      title: '未及时延误原因', dataIndex: 'waywya', align: 'center',
      children: [
        {
          title: '未及时票数',
          dataIndex: 'delayedCount',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => v || 0,
        },
        {
          title: <TipTitle title="票数占比全国" tipContent="组织的延误票数/全国延误票数" />,
          dataIndex: 'ratioOfDelay',
          align: 'center',
          width: 100,
          ellipsis: true,
          render: (value, record) => {
            const { per, val } = getValueAndPer({
              value,
              dataIndex: 'ratioOfDelay',
              filterData: data[record.type] || [],
            });
            return <LineComp value={val} per={per} />;
          },
        },
        {
          title: '运输延误',
          dataIndex: 'transportCount',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => v || 0,
        },
        {
          title: <TipTitle title="运输占比" tipContent="组织的运输延误票数/组织的总票数" />,
          dataIndex: 'ratioOfTransport',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: (value, record) => {
            const { per, val } = getValueAndPer({
              value,
              dataIndex: 'ratioOfTransport',
              filterData: data[record.type] || [],
            });
            return <LineComp value={val} per={per} />;
          },
        },
        {
          title: '操作延误',
          dataIndex: 'operationCount',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => v || 0,
        },
        {
          title: <TipTitle title="操作占比" tipContent="组织的操作延误票数/组织的总票数" />,
          dataIndex: 'ratioOfOperation',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: (value, record) => {
            const { per, val } = getValueAndPer({
              value,
              dataIndex: 'ratioOfOperation',
              filterData: data[record.type] || [],
            });
            return <LineComp value={val} per={per} />;
          },
        },
      ]
    },

  ];
};

export const directionColumns = ({ locationData = [], areaData = [], baseDate, flowType = 10 }) => {
  const today = moment(baseDate).format('MM-DD');
  const yesterday = moment(baseDate).subtract(1, 'days').format('MM-DD');
  const beforeYesterday = moment(baseDate).subtract(2, 'days').format('MM-DD');
  const month = moment(baseDate).format('M').trim();
  // console.log("导出日期", baseDate);
  const data = {
    '1': areaData,
    '2': areaData,
    '3': locationData,
  };
  var columns = []
  columns.push({
    title: '营运区流向',
    align: 'center',
    dataIndex: 'provinceFlowName',
    width: 120,
    ellipsis: true,
  })
  if (flowType===20) {
    columns.push(
      {
        title: '分拨流向',
        align: 'center',
        dataIndex: 'centerFlowName',
        width: 150,
        ellipsis: true,
      })
  }
  columns.push(
    {
      title: '月对比', dataIndex: 'ydb', align: 'center',
      children: [
        {
          title: `${month}月累计`,
          dataIndex: 'ratioOfCurrentMonth',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: '月对比',
          dataIndex: 'ratioOfMonthOverMonth',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
      ]
    },

    {
      title: '周对比', dataIndex: 'zdb', align: 'center',
      children: [
        {
          title: (
            <div>
              <div>上周</div>
              <div>{getWeekScope(baseDate, 1)}</div>
            </div>
          ),
          dataIndex: 'ratioOfLastWeek',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: (
            <div>
              <div>本周</div>
              <div>{getWeekScope(baseDate, 0)}</div>
            </div>
          ),
          dataIndex: 'ratioOfCurrentWeek',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: '周对比',
          dataIndex: 'ratioOfWeekOverWeek',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
          // render: (value, record) => {
          //   const { per, val } = getValueAndPer({
          //     value,
          //     dataIndex: 'ratioOfWeekOverWeek',
          //     filterData: data[record.type] || [],
          //   });
          //   return <LineComp value={val} per={per} />;
          // },
        },
      ]
    },
    {
      title: '日对比', dataIndex: 'rdb', align: 'center',
      children: [
        {
          title: beforeYesterday,
          dataIndex: 'ratioOfBeforeYesterday',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: yesterday,
          dataIndex: 'ratioOfYesterday',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: today,
          dataIndex: 'ratioOfCurrentDay',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: '日对比',
          dataIndex: 'ratioOfDayOnDay',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
      ]
    },
    {
      title: '未及时延误原因', dataIndex: 'waywya', align: 'center',
      children: [
        {
          title: '未及时票数',
          dataIndex: 'delayedCount',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => v || 0,
        },
        {
          title: '运输延误',
          dataIndex: 'transportCount',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => v || 0,
        },
        {
          // title: '运输延误占比',
          title: <TipTitle title="延误占比" tipContent="组织的运输延误票数/组织的总票数" />,
          dataIndex: 'ratioOfTransport',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
        {
          title: '操作延误',
          dataIndex: 'operationCount',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => v || 0,
        },
        {
          // title: '操作延误占比',
          title: <TipTitle title="延误占比" tipContent="组织的操作延误票数/组织的总票数" />,
          dataIndex: 'ratioOfOperation',
          align: 'center',
          width: 80,
          ellipsis: true,
          render: v => ((v && (v * 100).toFixed(1)) || '0.0') + '%',
        },
      ]
    },

  );
  return columns;
};